/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const transitionRouter = {
    path: '/',
    component: () => import('@/views/base/Index'),
    children: [
      {
        name: '过渡费',
        path: 'transition/:id',
        component: () => import('@/views/transition/print'),
      },
    ],
  }
  
  export default transitionRouter